import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Email|Details|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsEmailsDetails';
export type SPCatalogsEmailsDetailsLocNames =
	| `${LocNameStart}NotificationsChangesSaved`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleEmailContext`
	| `${LocNameStart}LabelContext`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelItem`;

export const spCatalogsEmailsDetailsLocs: LocDefs<SPCatalogsEmailsDetailsLocNames> = {
	SPCatalogsEmailsDetailsNotificationsChangesSaved: {
		defaultValue: 'Changes saved',
		description: 'Notification message when changes are saved.',
		displayPath: `${pathStart}Changes saved`,
		displayType: 'Notification',
		legacyName: 'Core/Catalogs.Emails.Details.Notification.ChangesSaved',
		...sharedProperties,
	},
	SPCatalogsEmailsDetailsTitlePage: {
		defaultValue: 'Email Catalog Details',
		description: 'Page title',
		displayPath: `${pathStart}Page title`,
		displayType: 'Title',
		legacyName: 'Core/Catalogs.Emails.Details.Title.PageTitle',
		...sharedProperties,
	},
	SPCatalogsEmailsDetailsTitleEmailContext: {
		defaultValue: 'Email Context',
		description: 'Email Context title',
		displayPath: `${pathStart}Email Context title`,
		displayType: 'Title',
		legacyName: 'Core/Catalogs.Emails.Details.Title.Context',
		...sharedProperties,
	},
	SPCatalogsEmailsDetailsLabelContext: {
		defaultValue: 'Context',
		description: 'Label for: Context',
		displayPath: `${pathStart}Context`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.Context',
		...sharedProperties,
	},
	SPCatalogsEmailsDetailsLabelType: {
		defaultValue: 'Type',
		description: 'Label for: Type',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.Type',
		...sharedProperties,
	},
	SPCatalogsEmailsDetailsLabelItem: {
		defaultValue: 'Item',
		description: 'Label for: Item',
		displayPath: `${pathStart}Item`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.Item',
		...sharedProperties,
	},
};

export type SPCatalogsEmailsDetailsLocType = LocMap<SPCatalogsEmailsDetailsLocNames>;
